import { Fragment } from 'react';
import { getPatientInfoFields } from './patient-info';
import type { Patient } from '@/types/patient';

type Props = {
    patient?: Patient;
};

/**
 * Slim, read-only strip of the patient's registered data shown under the header —
 * always-visible context during the interview, deliberately outside the editable
 * document (the psychologist is not editing the patient record here).
 */
export default function PatientContextBar({ patient }: Props) {
    const fields = getPatientInfoFields(patient);
    if (fields.length === 0) return null;

    return (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
            {fields.map((field, index) => (
                <Fragment key={field.label}>
                    {index > 0 && (
                        <span aria-hidden className="text-border-strong">
                            ·
                        </span>
                    )}
                    <span>
                        <span className="sr-only">{field.label}: </span>
                        {field.value}
                    </span>
                </Fragment>
            ))}
        </div>
    );
}
